export const FeatureThatCanBeLimited = [
  {
    key: "CHAT_FILTERING",
    label: "Chat Filtering",
  },
  {
    key: "CHAT_DELETION",
    label: "Chat Deletion",
  },
  {
    key: "CONTACT_DELETION",
    label: "Contact Deletion",
  },
  {
    key: "CRM_ACCESS",
    label: "CRM Access",
  },
  {
    key: "BULK_MESSAGE_SENDING",
    label: "Bulk Message Sending",
  },
  {
    key: "CHANGE_SELF_EMAIL",
    label: "Change Self Email",
  },
];
